import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.user.buttons.game,
    props.user.buttons.favorite,
    props.user.favorites,
    (button, favorite_button, favorites) => {
        return {
            button,
            favorite_button,
            favorites
        }
    }
)